/**
 * Copyright (c) 2016-present GlossGenius. All rights reserved.
 */

import { useGGTheme } from 'hooks/theme/useGGTheme';

export function AboutContainer() {
  const {
    components: { Layout },
    pages: { About },
  } = useGGTheme();

  return (
    <Layout>
      <About />
    </Layout>
  );
}
